var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-chip',{attrs:{"outlined":""}},[_vm._v(" 本日の次回予約: "+_vm._s(_vm.isLoading ? '...' : _vm.count)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }